import AuditTemplate from './src/main';

/* istanbul ignore next */
AuditTemplate.install = function(Vue) {
  Vue.component(AuditTemplate.name, AuditTemplate);
};

export default AuditTemplate;
